import { render, staticRenderFns } from "./ArrowUpIcon.vue?vue&type=template&id=97f7586c&scoped=true"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=js"
import style0 from "./ArrowUpIcon.vue?vue&type=style&index=0&id=97f7586c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f7586c",
  null
  
)

export default component.exports